import styled from 'styled-components';

export const ModalContainer = styled.div`
  background: ${props => props.theme.colors.white};
  box-sizing: border-box;
  position: fixed;
  top: -600%;
  left: -600%;
`
